import config from "@/config"
//系统路由
const routes = [
  {
    name: "webIndex",
    path: "/",
    component: () => import(/* webpackChunkName: "layout" */ "@/views/web"),
    // redirect: config.DASHBOARD_URL || "/dashboard",
  },
  {
    name: "layout",
    path: "/",
    component: () => import(/* webpackChunkName: "layout" */ "@/layout"),
    redirect: config.DASHBOARD_URL || "/dashboard",
    children: [
      {
        name: "menu",
        path: "/system/menu",
        meta: {
          title: "菜单"
        },
        component: () => import(/* webpackChunkName: "menu" */ "@/pages/manage/menu")
      }
    ]
  },
  {
    name:'login',
    path: "/login",
    component: () => import(/* webpackChunkName: "login" */ "@/views/login"),
    meta: {
      title: "登录"
    }
  },
  {
    name:'userRegister',
    path: "/user_register",
    component: () => import(/* webpackChunkName: "userRegister" */ "@/views/login/userRegister"),
    meta: {
      title: "注册"
    }
  },
  // {
  //   path: "/store/joinStore",
  //   component: () => import("@/layout"),
  //   children: [
  //     {
  //       name: "joinStore",
  //       path: "/store/joinStore",
  //       meta: {
  //         title: "商户入驻"
  //       },
  //       component: () => import(/* webpackChunkName: "menu" */ "@/views/login/storeRegister")
  //     }
  //   ]
  // },
  // {
  //   path: "/home/index",
  //   component: () => import("@/layout"),
  //   children: [
  //     {
  //       name: "home",
  //       path: "/home/index",
  //       meta: {
  //         title: "首页"
  //       },
  //       component: () => import(/* webpackChunkName: "menu" */ "@/views/home/index")
  //     }
  //   ]
  // },
  {
    path: "/reset_password",
    component: () => import(/* webpackChunkName: "resetPassword" */ "@/views/login/resetPassword"),
    meta: {
      title: "重置密码"
    }
  }
]

export default routes
